// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"1da7d4d2","543":"e5a636ad"}[chunkId] + ".chunk.js";
};